import React from "react";
import AgentPerformance from "./agentPerformance";
import AgentOfferingTime from "./agentOfferingTime";
import axios from "axios";
import {
  Card,
  CardContent,
  Typography,
  Paper,
  Chip,
  Tooltip,
  Fade,
  CircularProgress,
  alpha,
} from "@mui/material";
import { Alert, Box, IconButton, Snackbar, Stack } from "@mui/material";
import { useLocation } from "react-router-dom";
import { Grid } from "@mui/material";
import { useState, useEffect } from "react";
import { useMediaQuery, useTheme } from "@mui/material";
import {
  Phone,
  PhoneCallback,
  Schedule,
  TrendingUp,
  Analytics,
  CallReceived,
  CallMade,
  AccessTime,
  Restaurant,
} from "@mui/icons-material";
import {
  LineChart,
  Line,
  AreaChart,
  Area,
  PieChart,
  Pie,
  Cell,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip as RechartsTooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";
import FilterListIcon from "@mui/icons-material/FilterList";

import {
  AGENT_INCOMMING_CALL,
  AGENT_INCOMMING_CALL_COUNTS,
  AGENT_OUTGOING_CALL_COUNTS,
  AGENT_OUTGOING_CALL,
  SHRIMP_LISTING_MASTER,
} from "../../constants";
import {
  CALL_STATISTICS,
  OUTGOING_CALL_REPORT,
  PARIVARTAN_CALLING_REPORT,
} from "../../constants";

import DateFilterComponent from "../FishFeed/CallingDashboard/DateFilterComponent";


import CallerComponent from "../Dialer/callerComponent";
import NewLeadFormComponent from "./NewLeadFormComponent";
import dayjs from "dayjs";
import FilterComponent from "./FilterCompoenent";
import IncomingCallDistributionComponent from "./IncomingCallDistribution";
import ExistingTimelineComponent from "./ExistingTimeline";



// Utility to get date string in YYYY-MM-DD
const getFormattedDate = (date) => date.toISOString().split("T")[0];

// Enhanced Summary Card with animations and icons
const SummaryCard = ({ title, value, subtext, icon, trend, color = "primary" }) => {
  const theme = useTheme();

  return (
    <Fade in timeout={800}>
      <Card
        elevation={0}
        sx={{
          borderRadius: 3,
          padding: 2.5,
          background: `linear-gradient(135deg, ${alpha(theme.palette[color].main, 0.1)}, ${alpha(theme.palette[color].main, 0.05)})`,
          border: `1px solid ${alpha(theme.palette[color].main, 0.2)}`,
          transition: "all 0.3s ease",
          height: "100%",
          position: "relative",
          overflow: "hidden",
          "&:hover": {
            transform: "translateY(-2px)",
            boxShadow: `0 8px 25px ${alpha(theme.palette[color].main, 0.15)}`,
          },
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            height: 3,
            background: `linear-gradient(90deg, ${theme.palette[color].main}, ${theme.palette[color].light})`,
          },
        }}
      >
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
          <Typography variant="subtitle2" fontWeight={600} color="text.secondary">
            {title}
          </Typography>
          {icon && (
            <Box
              sx={{
                p: 1,
                borderRadius: 2,
                backgroundColor: alpha(theme.palette[color].main, 0.1),
                color: theme.palette[color].main,
              }}
            >
              {icon}
            </Box>
          )}
        </Box>

        <Box display="flex" alignItems="baseline" gap={1} mb={1}>
          <Typography variant="h4" color={color} fontWeight="bold">
            {value}
          </Typography>
          {trend && (
            <Chip
              size="small"
              label={trend}
              color={trend.includes('+') ? 'success' : 'error'}
              variant="outlined"
              sx={{ fontSize: '0.7rem', height: 20 }}
            />
          )}
        </Box>

        {subtext && (
          <Typography variant="caption" color="text.secondary" fontWeight={500}>
            {subtext}
          </Typography>
        )}
      </Card>
    </Fade>
  );
};

// Chart Card wrapper
const ChartCard = ({ title, subtitle, children, action }) => {
  const theme = useTheme();

  return (
    <Fade in timeout={1000}>
      <Paper
        elevation={0}
        sx={{
          p: 3,
          borderRadius: 3,
          border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
          background: "rgba(255, 255, 255, 0.8)",
          backdropFilter: "blur(10px)",
          height: "100%",
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Box>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              {title}
            </Typography>
            {subtitle && (
              <Typography variant="body2" color="text.secondary">
                {subtitle}
              </Typography>
            )}
          </Box>
          {action}
        </Box>
        {children}
      </Paper>
    </Fade>
  );
};


const buttonStyle = {
  border: "1px solid #fff",
  borderRadius: "4px",
  margin: "5px",
  width: "40px",
  height: "40px",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#097969",
  color: "#fff",
  transition: "background-color 0.3s, transform 0.2s",
  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
};

const hoverEffects = (e, isHovering) => {
  e.currentTarget.style.backgroundColor = isHovering ? "#0B9B73" : "#097969";
  e.currentTarget.style.transform = isHovering ? "scale(1.05)" : "scale(1)";
};

function AgentDashboardComponent() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const empDetails = JSON.parse(localStorage.getItem("userData"));
  const location = useLocation();
  const { mobNo, lotNum } = location.state || {}; // Destructure the state

  const [tableMobile, setTableMobile] = useState("");
  const [formOpen, setFormOpen] = useState(false);
  const [FormMobileNo, setFormMobileNo] = useState("");
  const [auditMobNum, setAuditMobNum] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [severity, setSeverity] = useState("");
  const [message, setMessage] = useState("");
  const [dateFilter, setDateFilter] = useState('week');
  const [callID, setCallID] = useState("");
  const [callType, setCallType] = useState("");

   const [missedCallID, setMissdeCalID] = useState("");

  const [statisticsData, setStatisticsData] = useState([]);
   const [customStartDate, setCustomStartDate] = useState('');
    const [customEndDate, setCustomEndDate] = useState('');
    const [customApplied, setCustomApplied] = useState(false);
    
  const [loading, setLoading] = useState(true);

  const getDateRange = (filterType) => {
    const today = new Date();
    let startDate, endDate;

    switch (filterType) {
      case 'today':
        startDate = new Date(today);
        endDate = new Date(today);
        break;
      case 'yesterday':
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        startDate = new Date(yesterday);
        endDate = new Date(yesterday);
        break;
      case 'week':
        startDate = new Date(today);
        startDate.setDate(today.getDate() - 6);
        endDate = new Date(today);
        break;
      case 'month':
        startDate = new Date(today);
        startDate.setDate(today.getDate() - 29);
        endDate = new Date(today);
        break;
      case 'custom':
        startDate = customStartDate ? new Date(customStartDate) : new Date(today);
        endDate = customEndDate ? new Date(customEndDate) : new Date(today);
        break;
      default:
        startDate = new Date(today);
        startDate.setDate(today.getDate() - 6);
        endDate = new Date(today);
    }

    return {
      startDate: getFormattedDate(startDate),
      endDate: getFormattedDate(endDate)
    };
  };

  const agent = JSON.parse(localStorage.getItem("userData"));
  const agentNumber = agent?.EmployeePhone;
  // console.log("agentNumber :::",agentNumber);


    const { startDate, endDate } = (dateFilter === 'custom' && customApplied)
    ? { startDate: customStartDate, endDate: customEndDate }
    : getDateRange(dateFilter);

  
     const [incoming, setIncoming] = useState(null);
    const [outgoing, setOutgoing] = useState(null);

  const [leadDetailId, setLeadDetailId] = useState("");

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  
  // Helper function to get filter display text
  const getFilterDisplayText = () => {
    if (dateFilter === 'custom' && customApplied && customStartDate && customEndDate) {
      return `Custom (${customStartDate} to ${customEndDate})`;
    }
    switch (dateFilter) {
      case 'today':
        return 'Today';
      case 'yesterday':
        return 'Yesterday';
      case 'week':
        return 'Past 7 Days';
      case 'month':
        return 'Past 30 Days';
      default:
        return 'Past 7 Days';
    }
  };
  

  const today = dayjs().startOf("day");
  
  const [filters, setFilters] = useState({
    startDate: today.subtract(6, "day").format("YYYY-MM-DD"),
    endDate: today.format("YYYY-MM-DD"),
    agentName: "",
    page: 1,         
    pageSize: 10
  });

  const [callData, setCallData] = useState([]);
  const [metricData, setMetricData] = useState([]);
  const [filterShow, setFilterShow] = useState(false);
  const [trendData, setTrendData] = useState([]);


  const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
    if (dateFilter === 'custom' && !customApplied) return;
    const fetchData = async () => {
      try {
        setLoading(true);        
       const [incomingRes, outgoingRes] = await Promise.all([
  axios.get(
    `${AGENT_INCOMMING_CALL_COUNTS}?startDate=${startDate}&endDate=${endDate}&agentNumber=${agentNumber}`
    // `${AGENT_INCOMMING_CALL_COUNTS}?startDate=2025-07-30&endDate=2025-07-30&agentNumber=${agentNumber}`
  ),
  axios.get(
    `${AGENT_OUTGOING_CALL_COUNTS}?startDate=${startDate}&endDate=${endDate}&agentNumber=${agentNumber}`
    // `${AGENT_OUTGOING_CALL_COUNTS}?startDate=2025-07-30&endDate=2025-07-30&aPartyNo=${agentNumber}`
  )
]);
        setIncoming(incomingRes.data);
        setOutgoing(outgoingRes.data);

   // for week days --->

      const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
      const totalIncoming = incomingRes.data?.summary?.totalCalls ?? 0;
      const totalOutgoing = outgoingRes.data?.summary?.totalCalls ?? 0;
      const generatedTrendData = days.map(day => ({
        day,
        incoming: Math.round(totalIncoming / 7),
        outgoing: Math.round(totalOutgoing / 7),
      }));
      setTrendData(generatedTrendData);

      } catch (error) {
        console.error(error);
        setMessage("Error loading dashboard data");
        setSeverity("error");
        // setOpenSnackbar(true);
      } finally {
        setLoading(false);
      }
    };
   
    fetchData();
   
  }, [dateFilter, agentNumber, startDate, endDate, customApplied]);
  
  
  console.log("incoming===============",incoming);
  console.log("outgoing===============",outgoing);
  
  const handleFilterChange = (newFilter) => {
    setDateFilter(newFilter);
    if (newFilter !== 'custom') {
      setCustomApplied(false);
    }
  };

  
  const handleCustomDateChange = (type, value) => {
    if (type === 'start') setCustomStartDate(value);
    if (type === 'end') setCustomEndDate(value);
    setCustomApplied(false);
  };

  const handleApplyCustom = (start, end) => {
    setCustomStartDate(start);
    setCustomEndDate(end);
    setCustomApplied(true);
  };

  
  // Prepare chart data
  const callDistributionData = incoming && outgoing ? [
    { name: 'Incoming', value: incoming.summary.totalCalls, color: theme.palette.primary.main },
    { name: 'Outgoing', value: outgoing.summary.totalCalls, color: theme.palette.secondary.main },
  ] : [];

  const connectionRateData = incoming && outgoing ? [
    {
      name: 'Incoming',
      connected: incoming.summary.connectedCalls,
      missed: incoming.summary.missedCalls,
      total: incoming.summary.totalCalls,
    },
    {
      name: 'Outgoing',
      connected: outgoing.summary.connectedCalls,
      missed: outgoing.summary.notConnectedCalls,
      total: outgoing.summary.totalCalls,
    },
  ] : [];

  // Mock trend data (you can replace with actual historical data)
  const trendData1= [
    { day: 'Mon', incoming: 12, outgoing: 8 },
    { day: 'Tue', incoming: 15, outgoing: 10 },
    { day: 'Wed', incoming: 18, outgoing: 12 },
    { day: 'Thu', incoming: 14, outgoing: 9 },
    { day: 'Fri', incoming: 16, outgoing: 11 },
    { day: 'Sat', incoming: 10, outgoing: 7 },
    { day: 'Sun', incoming: 8, outgoing: 5 },
  ];
  
  const [isInLoading, setIsInLoading] = useState(true);  
  const [connectedCalls, setConnectedCalls] = useState([]);
  const [notConnectedCalls, setNotConnectedCalls] = useState([]);
  const [totalOutCall, setTotalOutCall] = useState(0);

  const fetchOutgoingCallStatistics = () => {
    const { startDate, endDate } = filters;

    const formattedStartDate = dayjs(startDate).format("YYYY-MM-DD");
    const formattedEndDate = dayjs(endDate).format("YYYY-MM-DD");

    const queryParams = new URLSearchParams();
    queryParams.append("startDate", formattedStartDate);
    queryParams.append("endDate", formattedEndDate);
    queryParams.append("aPartyNo", empDetails.EmployeePhone);
    setIsLoading(true);
    axios
      .get(`${OUTGOING_CALL_REPORT}?${queryParams.toString()}`)
      .then((response) => {
        setTotalOutCall(response.data.totalCalls);
        setConnectedCalls(response.data.connected);
        setNotConnectedCalls(response.data.notConnected);
  
      })
      .catch((error) => {
        console.error(error);
      }).finally(() => {
        setIsLoading(false); // Stop loading after data fetch
      });
  };

  const [filtersLoaded1, setFiltersLoaded1] = useState(false); // Track if filters are loaded

  useEffect(() => {
    // Load filters from localStorage on page load
    const savedFilters = localStorage.getItem("dashboardfilters");

    if (savedFilters) {
      const loadedFilters = JSON.parse(savedFilters);

      // Check if the filters have changed compared to the initial state
      if (
        loadedFilters.startDate !== filters.startDate ||
        loadedFilters.endDate !== filters.endDate ||
        loadedFilters.agentName !== filters.agentName
      ) {
        setFilters(loadedFilters); // Only set the new filters if they are different
      }
    }

    // Set filtersLoaded to true after initial load to prevent premature API call
    setFiltersLoaded1(true);
  }, []); // This runs only once on initial load

  // dummy data

  const incomingVal = {
  summary: {
    totalCalls: 20,
    connectedCalls: 14,
    missedCalls: 6,
    totalDuration: "00:42:30" // Format: HH:MM:SS
  }
};

const outgoingVal = {
  summary: {
    totalCalls: 25,
    connectedCalls: 18,
    missedCalls: 7, // "Not Connected"
    totalDuration: "01:05:45" // Format: HH:MM:SS
  }
};

const callDistributionDataVal = [
  { name: "Incoming", value: 40, color: "#1976d2" },   // primary
  { name: "Outgoing", value: 60, color: "#9c27b0" }    // secondary
];


const connectionRateDataVal = [
  { name: "Agent A", connected: 20, missed: 5 },
  { name: "Agent B", connected: 15, missed: 8 },
  { name: "Agent C", connected: 25, missed: 4 },
  { name: "Agent D", connected: 18, missed: 6 },
  { name: "Agent E", connected: 10, missed: 10 }
];

const trendDataVal = [
  { day: "Mon", incoming: 12, outgoing: 8 },
  { day: "Tue", incoming: 9, outgoing: 11 },
  { day: "Wed", incoming: 15, outgoing: 10 },
  { day: "Thu", incoming: 8, outgoing: 14 },
  { day: "Fri", incoming: 10, outgoing: 13 },
  { day: "Sat", incoming: 6, outgoing: 9 },
  { day: "Sun", incoming: 4, outgoing: 5 }
];

console.log("outgoing:::",outgoing);

  return (
    <>
   
      <Grid
        container
        spacing={2}
        style={{
          flexWrap: "wrap", // Allow components to wrap on smaller screens
        }}
      >
        {/* Conditional Content Based on formOpen */}
        {formOpen ? (
          <>
            {/* Existing Data Section */}
            <Grid
              item
              xs={12}
              sm={5}
              md={5}
              style={{
                flexGrow: 1, // Make this take up remaining space
              }}
            >
              <ExistingTimelineComponent
                FormMobileNo={FormMobileNo}
                leadDetailId={leadDetailId}
                
              />
            </Grid>

            {/* Audit Form Section */}
            <Grid
              item
              xs={12}
              sm={4}
              md={4}
              style={{
                flex: "1 1 350px", // Ensure AuditFormComponent has a minimum width
                minWidth: "300px", // Minimum width for responsiveness
              }}
            >
              <NewLeadFormComponent
                setFormOpen={setFormOpen}
                FormMobileNo={FormMobileNo}
                setOpenSnackbar={setOpenSnackbar}
                setSeverity={setSeverity}
                setMessage={setMessage}
                mobNo={mobNo}
                setLeadDetailId={setLeadDetailId}
                
              />
            </Grid>
          </> 
        ) : (
          <>
            {/* Filter and Performance Section */}

             <Grid item xs={12} md={8}>
                {/* Header Section */}
                <Box sx={{ mb: 4 }}>
                  <Box display="flex" alignItems="center" gap={2} mb={1}>
                    {/* <Restaurant color="primary" sx={{ fontSize: 32 }} /> */}
                    <Typography variant="h4" fontWeight="bold" color="primary">
                      Dashboard 
                    </Typography>
                  </Box>
                  <Box display="flex" alignItems="center" gap={1} mb={3}>
                    <Schedule fontSize="small" color="action" />
                    <Typography variant="body1" color="text.secondary">
                      Analytics for {getFilterDisplayText()}: <strong>{startDate}</strong> to <strong>{endDate}</strong>
                    </Typography>
                  </Box>

                  {/* DATE FILTER COMPONENT */}
                  <DateFilterComponent
                    selectedFilter={dateFilter}
                    onFilterChange={handleFilterChange}
                    customStartDate={customStartDate}
                    customEndDate={customEndDate}
                    onCustomDateChange={handleCustomDateChange}
                    onApplyCustom={handleApplyCustom}
                  />
                </Box>
                {/* Key Metrics Cards - Incoming */}
                <Grid container spacing={3} mb={4}>
                  {incoming && (
                    <>
                      <Grid item xs={12} sm={6} md={3}>
                        <SummaryCard
                          title="Incoming Calls"
                          value={incoming.summary.totalCalls}
                    
                          icon={<CallReceived />}
                          color="primary"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={3}>
                        <SummaryCard
                          title="Connected (In)"
                          value={incoming.summary.connectedCalls}
                          icon={<Phone />}
                          color="success"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={3}>
                        <SummaryCard
                          title="Missed (In)"
                          value={incoming.summary.missedCalls}
                          icon={<PhoneCallback />}
                          color="warning"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={3}>
                        <SummaryCard
                          title="Duration (In)"
                          value={incoming.summary.totalDuration}
                          icon={<AccessTime />}
                          color="info"
                        />
                      </Grid>
                    </>
                  )}
                </Grid>
                {/* Key Metrics Cards - Outgoing */}
                <Grid container spacing={3} mb={4}>
                  {outgoing && (
                    <>
                      <Grid item xs={12} sm={6} md={3}>
                        <SummaryCard
                          title="Outgoing Calls"
                          value={outgoing?.summary?.totalCalls ?? 0}
                          icon={<CallMade />}
                          color="secondary"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={3}>
                        <SummaryCard
                          title="Connected (Out)"
                          value={outgoing?.summary?.connectedCalls?? 0}
                          icon={<Phone />}
                          color="success"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={3}>
                        <SummaryCard
                          title="Not Connected"
                          value={outgoing?.summary?.notConnectedCalls?? 0}
                          icon={<PhoneCallback />}
                          color="warning"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={3}>
                        <SummaryCard
                          title="Duration (Out)"
                          value={outgoing?.summary?.totalConnectedDuration?? 0}
                          icon={<AccessTime />}
                          color="info"
                        />
                      </Grid>
                    </>
                  )}
                </Grid>

                {/* Charts Section */}
                <Grid container spacing={3} mb={4}>
                  {/* Call Distribution Pie Chart */}
                  {/* <Grid item xs={12} md={6}>
                    <ChartCard
                      title="Call Distribution"
                      subtitle="Incoming vs Outgoing calls"
                      action={
                        <Tooltip title="View analytics">
                          <IconButton>
                            <Analytics />
                          </IconButton>
                        </Tooltip>
                      }
                    >
                      <ResponsiveContainer width="100%" height={250}>
                        <PieChart>
                          <Pie
                            data={callDistributionData}
                            cx="50%"
                            cy="50%"
                            outerRadius={80}
                            dataKey="value"
                            label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
                          >
                            {callDistributionData.map((entry, index) => (
                              <Cell key={`cell-${index}`} fill={entry.color} />
                            ))}
                          </Pie>
                          <RechartsTooltip />
                          <Legend />
                        </PieChart>
                      </ResponsiveContainer>
                    </ChartCard>
                  </Grid> */}

                  {/* Connection Rate Bar Chart */}
                  <Grid item xs={12} md={12}>
                    <ChartCard
                      title="Connection Analysis"
                      subtitle="Connected vs Missed calls"
                      action={
                        <Tooltip title="View trends">
                          <IconButton>
                            <TrendingUp />
                          </IconButton>
                        </Tooltip>
                      }
                    >
                      <ResponsiveContainer width="100%" height={250}>
                        <BarChart data={connectionRateData} barSize={120}>
                          <CartesianGrid strokeDasharray="3 3" stroke={alpha(theme.palette.divider, 0.3)} />
                          <XAxis dataKey="name" />
                          <YAxis />
                          <RechartsTooltip />
                          <Legend />
                          <Bar dataKey="connected" stackId="a" fill={theme.palette.success.main} name="Connected" />
                          <Bar dataKey="missed" stackId="a" fill={theme.palette.warning.main} name="Missed" />
                        </BarChart>
                      </ResponsiveContainer>
                    </ChartCard>
                  </Grid>

                  {/* Weekly Trend Line Chart */}
                  {/* <Grid item xs={12}>
                    <ChartCard
                      title="Call Trends"
                      subtitle={`Daily call patterns for ${getFilterDisplayText().toLowerCase()}`}
                    >
                      <ResponsiveContainer width="100%" height={300}>
                        <AreaChart data={trendData}>
                          <defs>
                            <linearGradient id="colorIncoming" x1="0" y1="0" x2="0" y2="1">
                              <stop offset="5%" stopColor={theme.palette.primary.main} stopOpacity={0.3} />
                              <stop offset="95%" stopColor={theme.palette.primary.main} stopOpacity={0} />
                            </linearGradient>
                            <linearGradient id="colorOutgoing" x1="0" y1="0" x2="0" y2="1">
                              <stop offset="5%" stopColor={theme.palette.secondary.main} stopOpacity={0.3} />
                              <stop offset="95%" stopColor={theme.palette.secondary.main} stopOpacity={0} />
                            </linearGradient>
                          </defs>
                          <CartesianGrid strokeDasharray="3 3" stroke={alpha(theme.palette.divider, 0.2)} />
                          <XAxis dataKey="day" />
                          <YAxis />
                          <RechartsTooltip />
                          <Legend />
                          <Area
                            type="monotone"
                            dataKey="incoming"
                            stroke={theme.palette.primary.main}
                            fillOpacity={1}
                            fill="url(#colorIncoming)"
                            name="Incoming Calls"
                          />
                          <Area
                            type="monotone"
                            dataKey="outgoing"
                            stroke={theme.palette.secondary.main}
                            fillOpacity={1}
                            fill="url(#colorOutgoing)"
                            name="Outgoing Calls"
                          />
                        </AreaChart>
                      </ResponsiveContainer>
                    </ChartCard>
                  </Grid> */}
                </Grid>

                {/* Shrimp Feed Section */}
                {/* <Box>
                  <Typography variant="h6" fontWeight="bold" mb={2} display="flex" alignItems="center" gap={1}>
                    <Restaurant color="primary" />
                    Shrimp Feed Details
                  </Typography>
                  <Grid container spacing={3}>
                    {shrimp && (
                      <Grid item xs={12} sm={6} md={3}>
                        <SummaryCard
                          title="Total Records"
                          value={shrimp.data.totalCount}
                          icon={<Analytics />}
                          color="primary"
                        />
                      </Grid>
                    )}
                  </Grid>
                </Box> */}
              </Grid>

              {/* // this section was present earlier ----->  */}
{/* 
            <Grid item xs={12} md={8}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  width: "100%",
                  marginBottom: 1,
                }}
              >
                {filterShow && (
                  <FilterComponent
                    filters={filters}
                    setFilters={setFilters}
                    data={callData}
                    setFilterShow={setFilterShow}
                  />
                )}

                <IconButton
                  onClick={() => setFilterShow((prev) => !prev)}
                  style={buttonStyle}
                  onMouseEnter={(e) => hoverEffects(e, true)}
                  onMouseLeave={(e) => hoverEffects(e, false)}
                >
                  <FilterListIcon />
                </IconButton>
              </Box>
              <IncomingCallDistributionComponent
                metricData={metricData}
                filters={filters}
                isInLoading={isInLoading}
              />
            </Grid>  */}
            

            {/* Agent Wise Summary Report Section */}
             {/* <Grid item xs={12} md={8}>
              <OutgoingCallDistributionComponent
                connectedCalls={connectedCalls}
                notConnectedCalls={notConnectedCalls}
                totalOutCall={totalOutCall}
                filters={filters}
                isLoading={isLoading}
              />
            </Grid>  */}

            {/* <Grid item xs={12} md={8}>
        <CallDistributionByAgentComponent
          metricData={metricData}
          filters={filters}
        />
      </Grid>

      <Grid item xs={12} md={8}>
        <OutboundCallDistributionComponent
          callStatistics={outCallStatistics}
          metricData={outMetrics}
          filters={filters}
        />
      </Grid> */}
          </>
        )}

        {/* Caller Component Section (Always Displayed) */}
        <Grid
          item
          xs={12}
          sm={4}
          md={4}
          style={{
            position: "fixed",
            // top: 0,
            right: 0,
            width: "300px", // Fixed width for CallerComponent
            // height: "100vh", // Full height of the viewport
            // overflowY: "auto",
            zIndex: 1000, // Ensure it appears on top of other content
          }}
        >
          <CallerComponent
            tableMobile={tableMobile}
            setFormOpen={setFormOpen}
            setFormMobileNo={setFormMobileNo}
            auditMobNo={mobNo}
            setAuditMobNum={setAuditMobNum}
            setOpenSnackbar={setOpenSnackbar}
            setSeverity={setSeverity}
            setMessage={setMessage}
            setCallID={setCallID}
            missedCallID={missedCallID}
            setCallType={setCallType}
          />
        </Grid>
      </Grid>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000} // Snackbar will auto hide after 6 seconds
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={severity}
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
    </>

);
}

export default AgentDashboardComponent;
